import { IMapCoordinates, IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { IInfrastructureData } from 'shared/mf-infrastructure/types/infrastructure';
import { ITAInfrastructureData, TTAInfrastructureType } from 'shared/mf-infrastructure/types/transportAccessibility';
import { getGeoObject } from 'shared/mf-infrastructure/utils/getGeoObject';

export function toGeoObjects(
  infrastructureByYear: Map<number, IInfrastructureData>,
  year: number,
  onlyExisting = true,
  showOfferMarker = true,
) {
  const geoObjectsData = infrastructureByYear.get(year)?.geoObjectsData || [];

  if (onlyExisting) {
    return geoObjectsData
      .filter(datum => !(datum.infrastructureItem && 'constructionYearFrom' in datum.infrastructureItem))
      .map(datum => datum.geoObject)
      .map(geoObject => getOfferMarker(geoObject, showOfferMarker));
  }

  return geoObjectsData.map(datum => getOfferMarker(datum.geoObject, showOfferMarker));
}

export function toTransportAccessibilityGeoObjects(
  transportAccessibilityInfrastructureByType: Map<TTAInfrastructureType, ITAInfrastructureData>,
  infrastructureType: TTAInfrastructureType,
  showOfferMarker = true,
) {
  const geoObjectsData = transportAccessibilityInfrastructureByType.get(infrastructureType)?.geoObjectsData || [];

  return geoObjectsData.map(datum => getOfferMarker(datum.geoObject, showOfferMarker));
}

function getOfferMarker(geoObject: IMapGeoObject, showOfferMarker: boolean): IMapGeoObject {
  if (showOfferMarker || geoObject.options.id !== '#main-pin') {
    return geoObject;
  }

  return getGeoObject({
    type: 'main',
    coordinates: geoObject.options.coordinates as IMapCoordinates,
    id: '#main-pin',
  });
}
